module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\"><defs><style> .a { fill: #6ca0b8; } </style></defs><title>listarrow</title><polygon class=\"a\" points=\"0 0 15 7.5 0 15 0 0\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/listarrow.svg
// module id = 505
// module chunks = 1